import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { NgModule } from '@angular/core';
import { UserManagementComponent } from './user-management.component';
import { UserManagementRoutingModule } from './user-management-routing.module';
import { UserTableModule } from './components/user-table/user-table.module';
import { DialogModule } from 'primeng/dialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { SelectModule } from 'primeng/select';
import { ReactiveFormsModule } from '@angular/forms';
import { SkeletonModule } from 'primeng/skeleton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { DrawerModule } from 'primeng/drawer';
import { ConfigureUserDialogModule } from './components/configure-user-dialog/configure-user-dialog.module';

@NgModule({
  declarations: [UserManagementComponent],
  imports: [
    ButtonModule,
    CommonModule,
    DialogModule,
    DrawerModule,
    SelectModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    ReactiveFormsModule,
    SkeletonModule,
    ToastModule,
    UserManagementRoutingModule,
    UserTableModule,
    ConfirmDialogModule,
    DynamicDialogModule,
    ConfigureUserDialogModule,
  ],
})
export class UserManagementModule {}
